import React, { Component } from 'react';

import * as apiConstant from '../../../api/apiConstant';
import * as UTILS from '../../../config/utils';

/****************************************
    Component for Photo Article Block on Home Page
    @author  IMH003
    @date    2020.05.22
    @version 0.1    
 ******************************************/
class PhotoArticleBlock extends Component {
    
    constructor(props) {
        super(props);
        
        this.main_media_type = 0;
        this.main_media_img  = "";
        this.arrMedia = [];

        this.waitAndEllipsis = this.waitAndEllipsis.bind(this);
        this.ellipsisStyle = this.ellipsisStyle.bind(this);
    }

    componentWillMount() {
        var mainMedia = this.props.medias.length > 0 ? this.props.medias[0] : {};

        if (this.props.medias.length > 0) {
            this.main_media_type = mainMedia.type;
            this.main_media_img = mainMedia.name;
            this.arrMedia = this.props.medias.slice(1, this.props.medias.length);
        }
    }

    componentDidMount() {        
        window.addEventListener('resize', this.waitAndEllipsis); 
    }
  
    componentDidUpdate() {  
        setTimeout(this.ellipsisStyle, 400);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.waitAndEllipsis);
    }

    componentWillReceiveProps(newProps) {
    }

    waitAndEllipsis() {
        setTimeout(this.ellipsisStyle, 800);
    }
    
    ellipsisStyle() {       
        window.ellipsisMe('#pa_' + this.props.business + '_' + this.props.id);
    }

    render() {

        if (this.main_media_type === 1) {
            return (
            
                <div className="testimonial col-sm-6 col-md-4 mb-4 mb-lg-0 col-lg-2">
                    <a href={apiConstant.desktop(this.props.business, this.props.id, this.main_media_img)} className="popular-category h-100 play-video">
                        <span className="icon"><span className="icon icon-video-camera"></span></span>
                        <span className="caption mb-2 d-block">&nbsp;</span>              
                        <span className="number ellipsis multiline" 
                            id={`pa_${this.props.business}_${this.props.id}`}
                            caption={UTILS.symbolingText(this.props.title)}
                            dangerouslySetInnerHTML={{__html: this.props.title}} />
                    </a>
                </div>
            );    
        }
        
        return (
            <div className="testimonial col-sm-6 col-md-4 mb-4 mb-lg-0 col-lg-2" data-lightbox="gallery">
                <a href={apiConstant.desktop(this.props.business, this.props.id, this.main_media_img)} 
                        className="popular-category h-100" 
                        data-lightbox="gallery-item"
                        caption = {this.props.title} >
                    <span className="icon"><span className={`icon ${this.main_media_type === 1 ? 'icon-video-camera' : 'icon-photo'}`}></span></span>
                    <span className="caption mb-2 d-block">&nbsp;</span>              
                    <span className="number ellipsis multiline" 
                            id={`pa_${this.props.business}_${this.props.id}`}
                            caption={UTILS.symbolingText(this.props.title)}
                            dangerouslySetInnerHTML={{__html: this.props.title}} />
                </a>
                {
                    this.arrMedia.map((media, key)=>(
                        <a 
                            key = {key}
                            href = {apiConstant.desktop(this.props.business, this.props.id, media.name)} 
                            data-lightbox = "gallery-item" 
                            className = "image-popup article-popup"
                            caption = {this.props.title}>
                        </a>
                    ))
                }
            </div>
        );
    }
}

export default PhotoArticleBlock;
